import { Component, EventEmitter, Input, Output } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-expansion-panel-item',
  templateUrl: './expansion-panel-item.component.html',
  styleUrls: ['./expansion-panel-item.component.scss'],
  animations: [
    trigger('contentExpansion', [
      state('expanded', style({height: '*', opacity: 1, visibility: 'visible'})),
      state('collapsed', style({height: '0px', opacity: 0, visibility: 'hidden'})),
      transition('expanded <=> collapsed',
        animate('200ms cubic-bezier(.37,1.04,.68,.98)')),
    ])
  ]
})
export class ExpansionPanelItemComponent {
  @Input() projectName: string = '';

  @Input() isOpened: boolean = false;
  
  @Output() toggle: EventEmitter<any> = new EventEmitter<any>();
  
  togglePanel() {
    this.toggle.emit(this);
  }
}
